/**
 * 品牌相關輔助函數
 * 提供統一的品牌名稱格式化和頁面標題生成
 */

import { BRAND_CONFIG } from '../config/brand';

/**
 * 生成標準的頁面標題
 * @param pageTitle 頁面特定標題
 * @returns 格式化的完整頁面標題
 */
export const generatePageTitle = (pageTitle?: string): string => {
  if (!pageTitle) {
    return `${BRAND_CONFIG.name} - ${BRAND_CONFIG.tagline}`;
  }
  return `${pageTitle} | ${BRAND_CONFIG.name}`;
};

/**
 * 生成邀請函標題
 * @param brideName 新娘姓名
 * @param groomName 新郎姓名
 * @returns 邀請函專用標題
 */
export const generateInvitationTitle = (brideName: string, groomName: string): string => {
  return `${brideName} & ${groomName} 的婚禮邀請函 | ${BRAND_CONFIG.name}`;
};

/**
 * 生成編輯頁面標題
 * @param brideName 新娘姓名
 * @param groomName 新郎姓名
 * @returns 編輯頁面標題
 */
export const generateEditTitle = (brideName?: string, groomName?: string): string => {
  if (brideName && groomName) {
    return `編輯邀請函 - ${brideName} & ${groomName} | ${BRAND_CONFIG.name}`;
  }
  return `編輯邀請函 | ${BRAND_CONFIG.name}`;
};

/**
 * 生成預設的 Meta Description
 * @param customDescription 自訂描述
 * @returns Meta description 內容
 */
export const generateMetaDescription = (customDescription?: string): string => {
  return customDescription || BRAND_CONFIG.description;
};

